import React, { useState } from 'react';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import ButtonGroup from '../elements/ButtonGroup';
import Button from '../elements/Button';
import Image from '../elements/Image';
import Modal from '../elements/Modal';
import Logo from '../layout/partials/Logo';
import RubberBand from 'react-reveal/RubberBand';
import Zoom from 'react-reveal/Zoom';
// import { Link } from 'react-router';


const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}

const Hero = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {

  const [videoModalActive, setVideomodalactive] = useState(false);

  const openModal = (e) => {
    e.preventDefault();
    setVideomodalactive(true);
  }

  const closeModal = (e) => {
    e.preventDefault();
    setVideomodalactive(false);
  }

  const outerClasses = classNames(
    'hero section center-content',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'hero-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container-sm">
        <div className={innerClasses}>
          <div className="hero-content">
            <div className="mt-0 mb-2 reveal-from-bottom" data-reveal-delay="300">
              <RubberBand >
                <Logo
                  width={400}
                  height={400}
                ></Logo>
              </RubberBand>
            </div>

            <h1 className="mt-0 mb-16 reveal-from-bottom" data-reveal-delay="200">
              <Zoom bottom cascade>
                Tecnology inspired by <span className="text-color-primary">nature</span>
              </Zoom>
            </h1>

            <div className="container-xs">
              <p className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="200">
                Mithikǝl has self-financed research, design and development of specialized technologies in mission-critical and high availability systems.
              </p>
              <div className="reveal-from-bottom" data-reveal-delay="400">
                <ButtonGroup>
                  <Button tag="a" color="primary" href='https://github.com/Mithikel/public-documents' >
                    Get started
                  </Button>
                  <Button tag="a" color="primary" href='mailto:official@mithikel.com?subject=Get started&body=' >
                    Contact us
                  </Button>
                  {/* <Button tag="a" color="dark" wideMobile href="https://github.com/cruip/open-react-template/">
                    View on Github
                  </Button> */}
                </ButtonGroup>

              </div>
            </div>
          </div>
          <div className="hero-figure reveal-from-bottom illustration-element-01" data-reveal-value="20px" data-reveal-delay="800">
            <a
              data-video="https://youtu.be/Mkfa3XBAOuc"
              href="#0"
              aria-controls="video-modal"
              onClick={openModal}
            >
              <Image
                className="has-shadow"
                src={require('./../../assets/images/video-placeholder.jpg')}
                alt="Hero"
                width={896}
                height={504} />
            </a>
          </div>
          <Modal
            id="video-modal"
            show={videoModalActive}
            handleClose={closeModal}
            video="https://youtu.be/Mkfa3XBAOuc"
            videoTag="iframe" />
        </div>
      </div>
    </section >
  );
}

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;

export default Hero;